<template>
  <div
    class="zo-loading"
    :qaid="`${qaId}_element`"
    :data-testid="`${dataTestid}_element`"
  >
    <ZoSpinner
      class="zo-loading--spinner"
      :qa-id="`${qaId}_spinner`"
      :data-testid="`${dataTestid}_spinner`"
    />
    <FontAwesomeIcon
      v-if="hasIcon"
      class="zo-loading--icon"
      :type="icon.type"
      :name="icon.name"
      :fw="icon.fw"
      :size="icon.size"
    />
    <span
      v-if="hasLoadingText"
      v-html="text"
      class="zo-loading--text"
      :class="{ 'text--subtle': subtleText }"
      :qa-id="`${qaId}_text`"
      :data-testid="`${dataTestid}_text`"
    />
  </div>
</template>

<script>
import FontAwesomeIcon from '@/components/elements/FontAwesomeIcon.vue';
import ZoSpinner from '@/components/elements/Spinner.vue';

export default {
  components: {
    ZoSpinner,
    FontAwesomeIcon,
  },

  props: {
    qaId: {
      type: String,
      default: 'loading',
    },
    dataTestid: {
      type: String,
      default: 'loading',
    },
    text: {
      type: String,
      default: 'loading...',
    },
    subtleText: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    hasLoadingText() {
      return !!this.text;
    },
    hasIcon() {
      return !!(this.icon.name && this.icon.type);
    },
  },
};
</script>

<style lang="scss">
  .zo-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--local-loader-padding, 0);
    position: relative;

    &--text {
      margin-left: var(--space-nudge);
    }

    &--icon {
      position: absolute;
      top: 50%;
      left: calc(var(--local-spinner-size) * .5em);
      transform: translate(-50%, -50%) scale(calc(var(--local-spinner-size) * .5));
    }
  }
</style>
